import { GridColDef } from '@mui/x-data-grid-premium';
import { baseCell } from 'components/cells';
import { filterOperators } from 'components/enhanced';
import { useTranslation } from 'react-i18next';

export function MedicalServicesEtlFieldColumns(): GridColDef[] {
  const { t } = useTranslation();

  return [
    {
      field: 'field_from',
      headerName: t(`global.field_from`),
      filterOperators,
      width: 200,
      editable: true,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'field_to',
      headerName: t(`global.field_to`),
      filterOperators,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'field_to_description',
      headerName: t(`global.field_to_description`),
      filterOperators,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'transcode',
      headerName: t(`global.transcode`),
      filterOperators,
      editable: true,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'order',
      headerName: t(`global.order`),
      editable: true,
      width: 200,
      sortable: false,
      renderCell: baseCell
    }
  ];
}
